import React from 'react';

import { Skeleton as AntSkeleton, SkeletonProps } from 'antd';

import { SkeletonButton } from './Button';
import { SkeletonAvatar } from './Avatar';
import { SkeletonImage } from './Image';
import { SkeletonInput } from './Input';

export interface ISkeletonProps extends SkeletonProps {}

type TSkeleton = React.FC<ISkeletonProps> & {
  Button: typeof SkeletonButton;
  Avatar: typeof SkeletonAvatar;
  Image: typeof SkeletonImage;
  Input: typeof SkeletonInput;
};

/**
 * Skeleton component
 * Provide a placeholder while you wait for content to load, or to visualise content that doesn't exist yet.
 */
export const Skeleton: TSkeleton = (props) => <AntSkeleton {...props} />;

Skeleton.Button = SkeletonButton;
Skeleton.Avatar = SkeletonAvatar;
Skeleton.Image = SkeletonImage;
Skeleton.Input = SkeletonInput;
